import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiCommonService } from '@api-services/api-common.service';
import { API_ROUTE_BASE } from '@constants/api-routes.constant';
import { ApiAlertError } from '@decorators/api-alert-error';
import { ExonerationZoneResult, ExonerationZoneResultJson } from '@models/exoneration-zone-result';

@Injectable({
  providedIn: 'root'
})
export class ExonerationZoneApiService extends ApiCommonService<ExonerationZoneResult> {
  readonly resourceUrl: string = `${API_ROUTE_BASE}/exoneration_zones`;

  @ApiAlertError()
  getExonerationZoneResult(code: string): Observable<ExonerationZoneResult> {
    return this.http
      .get<ExonerationZoneResultJson>(`${this.resourceUrl}/${code}`)
      .pipe(map((json: ExonerationZoneResultJson) => this.fromJson(json)));
  }

  fromJson(json: ExonerationZoneResultJson): ExonerationZoneResult {
    return ExonerationZoneResult.fromJson(json);
  }

  toJson(model: ExonerationZoneResult): never {
    throw new Error('Not usable');
  }
}
